import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mob-link-button',
  templateUrl: './link-button.component.html',
  styleUrls: ['./link-button.component.scss']
})
export class LinkButtonComponent {

    @Input() eventLabel = '';
    @Input() text = '';
    @Input() disabled:boolean= false;
    @Input() elementId = ''

    @Output() actionClick = new EventEmitter();

    constructor() { }
}
